module.exports = __webpack_public_path__ + "static/media/news-img1.a5948833.png";